import Strings from "../core/data/Strings";
import PlayerData from "../PlayerData";
import { GameScene, InGameMissionProgress } from "../scenes/GameScene";

export default class MissionTracker {
	scene: GameScene;
	missionUpdateTimer: number;
	missionDistance: number;
	missionCoins: number;
	updateFlag: boolean;

	notificationQueue: string[];

	constructor(scene: GameScene) {
		this.scene = scene;
		this.notificationQueue = [];
		this.missionUpdateTimer = 1;
		this.updateFlag = false;
	}

	updateMissionProgress(type: string, amt: number) {
		const mission = this.scene.currentMissionProgress.find((m) => m.type == type);
		if (mission) {
			mission.amt += amt;
		}
	}

	setMissionProgress(type: string, amt: number) {
		const mission = this.scene.currentMissionProgress.find((m) => m.type == type);
		if (mission) {
			mission.amt = amt;
		}
	}

	update(dt: number): void {
		if (this.updateFlag) return;
		if (this.missionDistance == undefined) {
			this.missionDistance = PlayerData.getMissionProgress("travelDistance");
			this.missionCoins = PlayerData.getMissionProgress("collectCoins");
		}

		this.missionUpdateTimer -= dt;
		if (this.missionUpdateTimer <= 0) {
			this.missionUpdateTimer = 1;

			this.setMissionProgress("travelDistance", this.scene.ltGame.getPlayerDistance() + this.missionDistance);
			this.setMissionProgress("collectCoins", this.scene.ltGame.coins + this.missionCoins);

			const missions = this.getMissionsComplete();
			if (missions.length > 0) {
				for (const mission of missions) {
					this.notificationQueue.push(Strings.get(mission.type + "Complete"));
				}
			}
		}

		if (this.scene.tweens.getTweensOf(this.scene.ui.missionGroup).length == 0 && this.notificationQueue.length > 0) {
			this.scene.ui.playMissionNotification(this.notificationQueue[0]);
			this.notificationQueue.splice(0, 1);
		}
	}

	getMissionsComplete(): InGameMissionProgress[] {
		const completedMissions: InGameMissionProgress[] = [];
		for (let i = 0; i < this.scene.currentMissionProgress.length; i++) {
			const mission = this.scene.currentMissionProgress[i];
			if (mission && mission.amt >= mission.goal && !mission.completed) {
				completedMissions.push(mission);
				mission.completed = true;
			}
		}
		return completedMissions;
	}

	finalMissionUpdate(distance: number, coins: number): void {
		this.updateFlag = true;
		PlayerData.setMissionProgress("travelDistance", distance + this.missionDistance);
		PlayerData.setMissionProgress("collectCoins", coins + this.missionCoins);
	}
}